import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PackagesListComponent} from './packages-list/packages-list.component';
import {WelcomeComponent} from './welcome/welcome.component';
import {PackagesListResolverService} from './services/packages-list-resolver.service';
import {WizardRoutes} from './wizard/wizard-routing';
import {UserNamespace} from '@namespaces/user.namespace';
import {CheckPermissionsGuardService} from '@services/guards/check-permissions.guard.service';
import {LaboratoryDocumentsResolverService} from '@providers/_resolvers/laboratory-documents-resolver.service';

export const packagesRoutes: Routes = [

    {
        path: '',
        canActivate: [CheckPermissionsGuardService],
        data: {
            permissions: [
                UserNamespace.Permission.accessModuleDocuments,
                UserNamespace.Permission.wizardDocumentsView,
            ],
            fallbackUrl: '/equipment'
        },
        children: [
            {
                path: '', redirectTo: 'index', pathMatch: 'full'
            },
            {
                path: 'index',
                component: PackagesListComponent,
                data: {title: 'Документы'},
                resolve: {
                    packageValue: PackagesListResolverService,
                    laboratoryDocuments: LaboratoryDocumentsResolverService,
                }
            },
            {
                path: 'welcome',
                component: WelcomeComponent,
                data: {title: 'Мастер создания документов'}
            },
            {
                path: 'wizard',
                canActivate: [CheckPermissionsGuardService],
                data: {
                    permissions: [
                        /**
                         * Пускаем в визард только если пользователь может редактировать визард и смотреть копии документы
                         */
                        UserNamespace.Permission.wizardDocumentsCreate,
                        UserNamespace.Permission.wizardDocumentsUpdate,
                        /**
                         * Если не может просматривать копии документов, то и в визарде делать нечего
                         */
                        UserNamespace.Permission.structureUnitDocumentList,
                    ],
                    fallbackUrl: '/'
                },
                children: [
                    ...WizardRoutes
                ]
            },
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(packagesRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class PackagesRoutingModule {
}
